(function() {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function initCalendar(section) {
        if (!section || section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        var zoneButtons = section.querySelectorAll('[data-zone]');
        var categoryButtons = section.querySelectorAll('[data-category-filter]');
        var searchInput = section.querySelector('[data-calendar-search]');
        var rows = Array.prototype.slice.call(section.querySelectorAll('.hg-calendar__row'));
        var cardsWrap = section.querySelector('[data-calendar-cards]');
        var empty = section.querySelector('[data-calendar-empty]');
        var currentZone = 'extreme';
        var currentCategory = 'all';

        function parseMonths(value) {
            if (!value) return [];
            return value
                .split(',')
                .map(function(month) {
                    return parseInt(month.trim(), 10);
                })
                .filter(function(month) {
                    return month >= 1 && month <= 12;
                });
        }

        function getActions(row, zone, month) {
            var actions = [];
            if (parseMonths(row.getAttribute('data-' + zone + '-sow')).indexOf(month) !== -1) actions.push('sow');
            if (parseMonths(row.getAttribute('data-' + zone + '-transplant')).indexOf(month) !== -1) actions.push('transplant');
            if (parseMonths(row.getAttribute('data-' + zone + '-harvest')).indexOf(month) !== -1) actions.push('harvest');
            return actions;
        }

        function renderTableBars() {
            rows.forEach(function(row) {
                row.querySelectorAll('.hg-calendar__bars').forEach(function(bars) {
                    bars.innerHTML = '';
                });

                for (var month = 1; month <= 12; month++) {
                    var cell = row.querySelector('[data-month="' + month + '"] .hg-calendar__bars');
                    if (!cell) continue;

                    getActions(row, currentZone, month).forEach(function(action) {
                        cell.insertAdjacentHTML('beforeend', '<span class="hg-calendar__bar ' + action + '"></span>');
                    });
                }
            });
        }

        function monthList(row, zone, action) {
            var values = parseMonths(row.getAttribute('data-' + zone + '-' + action));
            if (!values.length) return 'Not listed';
            return values.map(function(month) {
                return months[month - 1];
            }).join(', ');
        }

        function cardHtml(row) {
            var cropCell = row.querySelector('.hg-calendar__crop');
            var catCell = row.querySelector('.hg-calendar__cat');
            var crop = cropCell ? cropCell.textContent.trim() : '';
            var category = catCell ? catCell.textContent.trim() : '';

            var sow = monthList(row, currentZone, 'sow');
            var transplant = monthList(row, currentZone, 'transplant');
            var harvest = monthList(row, currentZone, 'harvest');

            var html = '<article class="hg-calendar__mobile-card" data-mobile-card="' + crop.toLowerCase() + '">';
            html += '<div class="hg-calendar__mobile-head">';
            html += '<div><h3 class="hg-calendar__mobile-title">' + crop + '</h3>';
            html += '<span class="hg-calendar__mobile-cat">' + category + '</span></div>';
            html += '</div>';
            html += '<div class="hg-calendar__mobile-summary">';
            html += '<p><i class="sow"></i><strong>Sow:</strong> ' + sow + '</p>';
            html += '<p><i class="transplant"></i><strong>Transplant:</strong> ' + transplant + '</p>';
            html += '<p><i class="harvest"></i><strong>Harvest:</strong> ' + harvest + '</p>';
            html += '</div>';
            html += '</article>';
            return html;
        }

        function renderCards(visibleRows) {
            if (!cardsWrap) return;
            cardsWrap.innerHTML = visibleRows.map(cardHtml).join('');
        }

        function applyFilters() {
            var search = searchInput ? searchInput.value.trim().toLowerCase() : '';
            var visibleRows = [];

            rows.forEach(function(row) {
                var crop = row.getAttribute('data-crop') || '';
                var category = row.getAttribute('data-category') || '';
                var matchesSearch = !search || crop.indexOf(search) !== -1 || category.toLowerCase().indexOf(search) !== -1;
                var matchesCategory = currentCategory === 'all' || category === currentCategory;
                var visible = matchesSearch && matchesCategory;

                row.style.display = visible ? '' : 'none';
                if (visible) visibleRows.push(row);
            });

            renderCards(visibleRows);

            if (empty) {
                empty.classList.toggle('is-active', visibleRows.length === 0);
            }
        }

        zoneButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                zoneButtons.forEach(function(btn) {
                    btn.classList.remove('is-active');
                });
                button.classList.add('is-active');
                currentZone = button.getAttribute('data-zone');
                renderTableBars();
                applyFilters();
            });
        });

        categoryButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                categoryButtons.forEach(function(btn) {
                    btn.classList.remove('is-active');
                });
                button.classList.add('is-active');
                currentCategory = button.getAttribute('data-category-filter');
                applyFilters();
            });
        });

        if (searchInput) {
            searchInput.addEventListener('input', applyFilters);
        }

        renderTableBars();
        applyFilters();
    }

    function initAll() {
        document.querySelectorAll('[data-hg-planting-calendar]').forEach(initCalendar);
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function(event) {
        initCalendar(event.target.querySelector('[data-hg-planting-calendar]'));
    });
})();

